import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setButtonAction, setHeader } from "../../reduxSlices/headerSlice";
import CommonDialog from "../dialog/CommonDialog";
import ContentLoader from "../loader/ContentLoader";
import styles from "./Categories.module.css";
import {
  getAnnualGivingTranslation,
  getAppealCategoryTranslation,
  getChannelTranslation,
  getFundPurposeTranslation,
  getPhilanthropicFundTranslation,
  getProgramTranslation,
} from "../../reduxSlices/translationSlice";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import CustomTooltip from "../tooltip/CustomTooltip";
import {
  allTranslations,
  annualGiving,
  appealCategories,
  channelCategories,
  fundPurpose,
  programCategories,
} from "../../constants/constant";
import { removeSlashesWithoutSpace } from "../../helpers/helper";

const Categories = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentUrl = removeSlashesWithoutSpace(window?.location?.pathname);
  const filterCategories =
    currentUrl && currentUrl === "channel-translation"
      ? channelCategories
      : currentUrl === "appeal-category-translation"
      ? appealCategories
      : currentUrl === "program-translation"
      ? programCategories
      : currentUrl === "annualgiving-translation"
      ? annualGiving
      : fundPurpose;
  const [open, setOpen] = useState(false);
  const [allCategory, setAllCategory] = useState(filterCategories);
  const headerData = useSelector((state) => state?.header);
  const buttonAction = headerData?.buttonAction;
  const loading = useSelector((state) => state.translation.loading);
  const transalationId = localStorage.getItem("transalationId");
  const selectedOrg = localStorage.getItem("selectedOrg");
  const parseOrg = JSON.parse(selectedOrg);
  const organisationId = parseOrg.organizationId;
  const allChannelTranslation = useSelector(
    (state) => state?.translation?.allChannelTranslation?.data
  );
  const transType = allChannelTranslation?.transType;
  const isTranslationAdded = allChannelTranslation?.isTranslationAdded;
  const filterTranslation =
    allTranslations &&
    allTranslations?.find(
      (item) => removeSlashesWithoutSpace(item?.navigate) === currentUrl
    );
  const page = removeSlashesWithoutSpace(filterTranslation?.navigate);
  const title = filterTranslation?.title;
  const subTitle = filterTranslation?.subTitle;

  useEffect(() => {
    console.log("xfchgvjhb", allCategory);
  }, [allCategory]);

  useEffect(() => {
    console.log("filterTranslation", filterTranslation);
  }, [filterTranslation]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getChannelTranslationData = async () => {
    const obj = {
      translationId: transalationId || "",
      organisationId: organisationId || "",
      transType: "",
    };
    if (transalationId === "1") {
      await dispatch(getChannelTranslation(obj));
    } else if (transalationId === "2") {
      await dispatch(getProgramTranslation(obj));
    } else if (transalationId === "3") {
      await dispatch(getAppealCategoryTranslation(obj));
    } else if (transalationId === "18") {
      await dispatch(getAnnualGivingTranslation(obj));
    } else if (transalationId === "8") {
      await dispatch(getFundPurposeTranslation(obj));
    } else {
      await dispatch(getPhilanthropicFundTranslation(obj));
    }
  };

  useEffect(() => {
    getChannelTranslationData();
  }, [dispatch, transalationId]);

  useEffect(() => {
    if (isTranslationAdded && transType) {
      const modifiedData = allCategory?.map((item) => {
        return item?.transType !== transType
          ? { ...item, isDisable: true }
          : item;
      });
      setAllCategory(modifiedData);
    }
  }, [isTranslationAdded, transType]);

  useEffect(() => {
    dispatch(
      setHeader({
        page: page || "",
        title: title || "",
        subTitle: subTitle || "",
      })
    );
    localStorage.setItem("mainTitle", "");
  }, []);

  useEffect(() => {
    if (
      (buttonAction.page === "channel-translation" ||
        buttonAction.page === "program-translation" ||
        buttonAction.page === "annualgiving-translation" ||
        buttonAction.page === "fundpurpose-translation" ||
        buttonAction.page === "philanthropic-translation" ||
        buttonAction.page === "appeal-category-translation") &&
      buttonAction.action === "cancel"
    ) {
      console.log("buttonAction called");
      handleClickOpen();
    }
    dispatch(
      setButtonAction({
        page: "",
        action: "",
      })
    );
  }, [buttonAction.page, buttonAction.action]);

  const handleGoBack = () => {
    navigate("/configure-translations");
    setOpen(false);
  };

  const handleTransType = (data) => {
    console.log("fgchvjb", data);
    let item = {
      ...data,
      mainTitle:
        transalationId === "3"
          ? "Appeal Category"
          : transalationId === "7"
          ? "Philanthropic Funds"
          : data?.mainTitle,
      transType:
        transalationId === "3" && data?.title === "Custom Fields Categories"
          ? "opt3"
          : data?.transType,
    };
    localStorage.setItem("transType", item?.transType);
    localStorage.setItem("page", removeSlashesWithoutSpace(item?.navigate));
    localStorage.setItem("mainTitle", item?.mainTitle);
    localStorage.setItem("title", item?.title);
    localStorage.setItem("subTitle", item?.subTitle);
  };

  if (loading) return <ContentLoader />;

  return (
    <>
      <div className={styles.pleaseChooseOne}>
        Please choose one of the following options
      </div>
      <div className={styles.mainDiv}>
        {allCategory?.map((item, i) => (
          <CustomTooltip
            key={i}
            title={
              item?.isDisable
                ? "To use this option, please delete your existing translation settings."
                : ""
            }
            placement="bottom"
          >
            <div
              className={styles.parentDiv}
              style={{ cursor: item?.isDisable ? "not-allowed" : "pointer" }}
            >
              <Link
                to={item?.isDisable ? "" : item?.navigate}
                onClick={() => (item?.isDisable ? null : handleTransType(item))}
                style={{
                  textDecoration: "none",
                  cursor: item?.isDisable ? "not-allowed" : "pointer",
                }}
              >
                {item?.isDisable && (
                  <div style={{ display: "flex", float: "right" }}>
                    <LockOutlinedIcon
                      style={{ color: "#56a5a1", margin: "10px" }}
                    />
                  </div>
                )}
                <div className={styles.cardContainer}>
                  <div className={styles.title}>{item?.title}</div>
                  <div className={styles.lastUpdatedSep1}>
                    {item?.description}
                  </div>
                </div>
              </Link>
            </div>
          </CustomTooltip>
        ))}
      </div>
      <CommonDialog
        open={open}
        setOpen={setOpen}
        handleCancel={handleClose}
        handleDone={handleGoBack}
        title="All changes will be lost"
        subTitle="Are you sure you want to discard changes?"
        leftButtonText="Cancel"
        rightButtonText="Discard"
      />
    </>
  );
};

export default Categories;
